export default __webpack_public_path__ + "static/media/resume.d3a2c56c.pdf";